<script lang="ts">
	import ArrowRightIcon from "@lucide/svelte/icons/arrow-right";
	import { Section, type SectionTheme } from "#lib/web-ui/primitives/index.js";

	interface EntryCard {
		eyebrow: string;
		title: string;
		description: string;
		href: string;
	}

	interface Props {
		locationLabel: string;
		headline: string;
		paragraph: string;
		cards: EntryCard[];
		fineText: string;
		formLinkLabel: string;
		formHref: string;
		theme?: SectionTheme;
		id?: string;
	}

	let {
		locationLabel,
		headline,
		paragraph,
		cards,
		fineText,
		formLinkLabel,
		formHref,
		theme = "dark",
		id
	}: Props = $props();
</script>

<Section {theme} {id} data-testid="associate-hero">
	<div class="max-w-3xl">
		<p class="text-primary text-sm font-semibold tracking-wide">{locationLabel}</p>
		<h1
			class="text-foreground mt-4 text-4xl font-bold tracking-tight text-balance md:text-5xl lg:text-6xl"
		>
			{headline}
		</h1>
		<p class="text-muted-foreground mt-6 text-lg text-pretty">{paragraph}</p>
	</div>

	<div class="mt-10 grid gap-4 md:grid-cols-2">
		{#each cards as card (card.href)}
			<a
				href={card.href}
				class="bg-card text-card-foreground hover:bg-accent focus-visible:ring-ring flex flex-col gap-2 rounded border p-6 transition-colors focus-visible:ring-2 focus-visible:outline-none"
			>
				<span class="text-primary text-xs font-semibold tracking-widest uppercase">
					{card.eyebrow}
				</span>
				<span class="text-card-foreground text-xl font-semibold">{card.title}</span>
				<span class="text-muted-foreground text-sm">{card.description}</span>
			</a>
		{/each}
	</div>

	<p class="text-muted-foreground mt-6 text-sm">
		{fineText}
		<a
			href={formHref}
			class="text-primary inline-flex items-center gap-1 font-semibold underline underline-offset-4"
		>
			{formLinkLabel}
			<ArrowRightIcon class="size-4" aria-hidden="true" />
		</a>
	</p>
</Section>
